
export default function MediaSection() {
  return (
    <section id="media" className="py-20 bg-gray-50 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center mb-6">
            <div className="w-16 h-px bg-amber-400"></div>
            <span 
              className="mx-6 text-amber-600 text-sm tracking-[0.3em] font-light uppercase"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              Media
            </span>
            <div className="w-16 h-px bg-amber-400"></div>
          </div>
          
          <h2 
            className="text-4xl md:text-5xl font-light text-gray-900 mb-4 tracking-wide"
            style={{ 
              fontFamily: '"Noto Serif JP", serif',
              letterSpacing: '0.02em'
            }}
          >
            メディア出演・取材のご依頼
          </h2>
          
          <p 
            className="text-lg text-gray-600 font-light"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.8'
            }}
          >
            執事文化とおもてなしをテーマにした<br />
            メディア出演・取材を承っております
          </p>
        </div>

        {/* Media Types */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {[
            { icon: 'ri-tv-line', label: 'テレビ' },
            { icon: 'ri-radio-line', label: 'ラジオ' },
            { icon: 'ri-newspaper-line', label: '新聞・雑誌' },
            { icon: 'ri-global-line', label: 'ウェブメディア' }
          ].map((media, index) => (
            <div 
              key={index}
              className="group relative bg-white p-6 shadow-sm hover:shadow-lg transition-all duration-500 cursor-pointer border border-gray-100 hover:border-amber-400/30"
            >
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-amber-100 rounded-full">
                  <i className={`${media.icon} text-2xl text-amber-700`}></i>
                </div>
                <div 
                  className="text-sm text-gray-700 group-hover:text-amber-700 transition-colors duration-300"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  {media.label}
                </div>
              </div>
              
              {/* Hover accent */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-amber-400 group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="/media"
            className="group relative inline-flex items-center text-amber-600 hover:text-amber-700 font-light text-lg transition-colors duration-300 cursor-pointer"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              letterSpacing: '0.1em'
            }}
          >
            <span className="mr-2">詳しく見る</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            
            {/* Underline animation */}
            <div className="absolute bottom-0 left-0 w-0 h-px bg-amber-600 group-hover:w-full transition-all duration-500"></div>
          </a>
        </div>
      </div>
    </section>
  );
}
